<template>
  <div class="">
    <images-edit> </images-edit>
  </div>
</template>

<script>
import ImagesEdit from "@/components/profile/lisacomunica/images/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    ImagesEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Immagini",
        path: "lisacomunica_template",
        tab: "Images",
        level: 3,
      });
      bcs.push({
        text: "Modifica template immagine",
        path: "images.edit",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Immagini",
        path: "lisacomunica_template",
        tab: "Images",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica template immagine",
        path: "images.edit",
        level: 4,
      });
    }
  },
};
</script>
